import actionTypes from 'src/modules/redux/actionTypes'

export const setProfilePaginationParams = params => ({
  type: actionTypes.SET_PROFILE_PAGINATION,
  payload: params
})